import { allFieldsValidationCommon } from "../Validation";
import { IAddress } from "../../classes/Domain";

const rules = {
    billingAddress: {
        street: 'required',
        city: 'required',
        zipCode: 'required',
        stateCode: 'required',
    }
};

export const allFieldsValidation = (data: { billingAddress: any }) => {
    return allFieldsValidationCommon(data, rules);
};